import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

const EPPlatformVersion = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const only_version = props?.only_version ?? false;
	const disabled = props?.disabled ?? false;
	const kind = props?.kind ?? 'plan';

	const getVersion = () => {
		const _v = props?.version ?? 'basic';
		if(_v === false) return 'empty';
		return _v;
	};

	const version = getVersion();
	const is_pro = (version == 'premiumpro' || version == 'basicpro') ? " PRO" : "";

	const getTypeLabel = () => {
		const is_plan = (kind == 'plan') ? " Plan" : "";

		if(version == 'corp' || version == 'corporate') return `Corporate${is_plan}`;
		if(version == 'corporate_plus') return `Corporate Plus${is_plan}`;
		if(version == 'wl' || version == 'whitelabel') return `White Label${is_plan}`;
		if(version == 'premium' || version == 'premiumpro') return `Premium${is_pro}${is_plan}`;
		if(version == 'basic' || version == 'basicpro') return `Basic${is_pro}${is_plan}`;
		return "No subscription";
	};

	const getTypeRotation = () => {
		if(version == 'corp' || version == 'corporate') return '50 30 30';
		if(version == 'corporate_plus') return `50 30 30`;
		if(version == 'wl' || version == 'whitelabel') return '50 30 30';
		if(version == 'premium' || version == 'premiumpro') return '65 30 30';
		if(version == 'basic' || version == 'basicpro') return '80 30 30';
		return '45 30 30';
	};

	const type_label = getTypeLabel();
	const type_rotation = getTypeRotation();

	return (
		<div class={`is_${version}`}>
			<div class={`ep_version${(only_version) ? ' only_version' : ''}`}>
				<div class="gui_ep_version_icon">
					<div class={`ep_icon ${version}_icon`}>
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" class={((disabled) ? 'disabledItem' : null)}>
							<circle cx="30" cy="30" r="27" class="disabler_section" />

							<circle cx="30" cy="30" r="27" transform={`rotate(${type_rotation})`} class="color_section" />

							<path class="ep_logo_icon" d="M64.7,31.4l-7.3-23c-0.2-0.5-0.3-0.9-0.6-1.3c-1.6-2.3-4.7-2.8-7-1.2l-32.7,23c-2.3,1.6-2.8,4.7-1.2,7c1,1.4,2.5,2.1,4.1,2.1h40c2.8,0,5-2.2,5-5C65,32.4,64.9,31.9,64.7,31.4z M48.5,16.5l-20,14c-0.2,0.2-0.5,0.2-0.7,0.2c-0.4,0-0.8-0.2-1-0.5c-0.4-0.6-0.3-1.3,0.3-1.7l20-14c0.6-0.4,1.3-0.3,1.7,0.3S49.1,16.1,48.5,16.5z" />
						</svg>

						{(is_pro) && (
							<span class="is_pro_mark">{i18n("PRO")}</span>
						)}
					</div>
				</div>

				{(type_label) && (
					<span class={`version_label${(disabled) ? ' disabledItem' : ''}`}>
						<strong>{i18n(type_label)}</strong>
					</span>
				)}

				{(props.children != undefined) && (
					<div class="additional_content">{props.children}</div>
				)}
			</div>
		</div>
	);
}

export default injectIntl(EPPlatformVersion);